import { render, staticRenderFns } from "./ScheduleBoard.vue?vue&type=template&id=17ba4f1b&scoped=true"
import script from "./ScheduleBoard.vue?vue&type=script&lang=js"
export * from "./ScheduleBoard.vue?vue&type=script&lang=js"
import style0 from "./ScheduleBoard.vue?vue&type=style&index=0&id=17ba4f1b&prod&lang=css"
import style1 from "./ScheduleBoard.vue?vue&type=style&index=1&id=17ba4f1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ba4f1b",
  null
  
)

export default component.exports